import camelCase from 'lodash/camelCase';
import mapV2 from './map-v2.js';
import sosCallV2 from './sos-call-v2.js';

const globModules = import.meta.glob('./*.js', { eager: true });
const modules = {};
for (const [fileName, module] of Object.entries(globModules)) {
  if (fileName === './index.js') continue;
  if (fileName === './map-v2.js') continue; // registered explicitly below with hyphenated key
  if (fileName === './sos-call-v2.js') continue; // registered explicitly below with hyphenated key
  const moduleName = camelCase(fileName.replace(/(\.\/|\.js)/g, ''));
  modules[moduleName] = module.default;
}

modules['map-v2'] = mapV2;
modules['sos-call-v2'] = sosCallV2;

export default modules;
